// import { getCurrentEmailsFromLocalStorage, setCurrentEmailsInLocalStorage } from "helpers/sf_utils"
import {
  GET_CLIENT_EMAIL_EVENTS,
  GET_CLIENT_EMAIL_EVENTS_SUCCESS,
  GET_CLIENT_EMAIL_EVENTS_ERROR,
  GET_CLIENT_EMAIL_TEMPLATE_BY_ID,
  GET_CLIENT_EMAIL_TEMPLATE_BY_ID_SUCCESS,
  GET_CLIENT_EMAIL_TEMPLATE_BY_ID_ERROR,
  RESET_CLIENT_EMAIL_TEMPLATE_BY_ID,
  CHECK_CLIENT_EMAIL_STATUS_BY_EVENT,
  CHECK_CLIENT_EMAIL_STATUS_BY_EVENT_SUCCESS,
  CHECK_CLIENT_EMAIL_STATUS_BY_EVENT_ERROR,
  DELETE_CLIENT_EMAIL_STATUS_BY_EVENT,
  DELETE_CLIENT_EMAIL_STATUS_BY_EVENT_SUCCESS,
  DELETE_CLIENT_EMAIL_STATUS_BY_EVENT_ERROR
} from "./actionTypes"
import { buildPaginationCacheKey } from "helpers/sf_utils"

const INIT_STATE = {
  // EMAIL_TEMPLATE_LOGS
  client_email_template_logs: null,
  client_email_template_logs_loading: false,
  client_email_template_logs_error: null,

  // EMAIL_EVENTS
  client_email_events: [],
  loading: false,
  last_fetched_at: null,
  last_page_fetched: 0,
  total_number_of_pages: 0,
  has_next_page: false,
  has_lookahead_pages: false,
  active_cache_key: null,
  page_cache: {},
  category_options: [],
  event_options: [],

  // EMAIL_STATUS_FROM_SENDGRID
  client_email_event_status_error: null,
  client_email_event_status: [],
  client_email_event_status_loading: false,
}
const ClientEmailEvents = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_CLIENT_EMAIL_EVENTS:
      let client_event_page_number = 1
      const appendResults = Boolean(action.payload?.appendResults)
      if (action.paginated) {
        client_event_page_number = action.payload?.queryParams?.page_number
      }
      const useCache = Boolean(action.payload?.useCache)
      const queryParams = action.payload?.queryParams || {}
      const cacheKey = useCache ? buildPaginationCacheKey(queryParams) : null
      const shouldResetCache =
        useCache &&
        client_event_page_number === 1 &&
        !appendResults &&
        state.active_cache_key &&
        state.active_cache_key !== cacheKey
      const cachedPage = useCache ? state.page_cache?.[cacheKey]?.[client_event_page_number] : null
      return {
        ...state,
        error: null,
        active_cache_key: useCache ? cacheKey : null,
        loading: !cachedPage,
        client_email_events: cachedPage?.rows || ((client_event_page_number === 1 || !appendResults) ? [] : state.client_email_events),
        last_page_fetched: cachedPage?.page_number || state.last_page_fetched,
        total_number_of_pages: cachedPage?.total_number_of_pages || state.total_number_of_pages,
        has_next_page: typeof cachedPage?.has_next_page === 'boolean' ? cachedPage.has_next_page : state.has_next_page,
        has_lookahead_pages: typeof cachedPage?.has_lookahead_pages === 'boolean' ? cachedPage.has_lookahead_pages : state.has_lookahead_pages,
        page_cache: shouldResetCache ? {} : state.page_cache,
      }

    case GET_CLIENT_EMAIL_EVENTS_SUCCESS:
      let uniqueClientEmailEvents = [];
      const appendClientEmailEvents = Boolean(action.meta?.appendResults)
      const rows = Array.isArray(action.payload.data) ? action.payload.data : []
      const all_client_email_events = appendClientEmailEvents ? [...state.client_email_events, ...rows] : rows
      const useCacheForSuccess = Boolean(action.meta?.useCache)
      const successQueryParams = action.meta?.queryParams || {}
      const successCacheKey = useCacheForSuccess ? buildPaginationCacheKey(successQueryParams) : null
      const safePage = parseInt(action.payload.additional_data?.page_number, 10) || 1
      const safeTotal = parseInt(action.payload.additional_data?.total_number_of_pages, 10) || 0
      const pageSnapshot = {
        rows,
        page_number: safePage,
        total_number_of_pages: safeTotal,
        has_next_page: action.payload.additional_data?.has_next_page || false,
        has_lookahead_pages: action.payload.additional_data?.has_lookahead_pages || false,
      }
      all_client_email_events.forEach(function (item) {
        const i = uniqueClientEmailEvents.findIndex(x => x.id == item.id);
        if (i <= -1) {
          uniqueClientEmailEvents.push(item);
        }
      });
      return {
        ...state,
        error: null,
        active_cache_key: useCacheForSuccess ? successCacheKey : state.active_cache_key,
        client_email_events: uniqueClientEmailEvents,
        loading: false,
        last_fetched_at: new Date(),
        last_page_fetched: safePage,
        total_number_of_pages: safeTotal,
        has_next_page: action.payload.additional_data?.has_next_page || false,
        has_lookahead_pages: action.payload.additional_data?.has_lookahead_pages || false,
        category_options: action.payload.additional_data?.category_options,
        event_options: action.payload.additional_data?.event_options,
        page_cache: useCacheForSuccess ? {
          ...state.page_cache,
          [successCacheKey]: {
            ...(state.page_cache?.[successCacheKey] || {}),
            [safePage]: pageSnapshot,
          },
        } : state.page_cache,
      }

    case GET_CLIENT_EMAIL_EVENTS_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
        has_next_page: false,
        has_lookahead_pages: false,
      }

    case GET_CLIENT_EMAIL_TEMPLATE_BY_ID:
      return {
        ...state,
        client_email_template_logs_error: null,
        client_email_template_logs_loading: true,
      }

    case GET_CLIENT_EMAIL_TEMPLATE_BY_ID_SUCCESS:
      return {
        ...state,
        client_email_template_logs_error: null,
        client_email_template_logs: { ...action.payload.data },
        client_email_template_logs_loading: false,
      }

    case GET_CLIENT_EMAIL_TEMPLATE_BY_ID_ERROR:
      return {
        ...state,
        client_email_template_logs_error: action.payload,
        client_email_template_logs_loading: false,
      }

    case CHECK_CLIENT_EMAIL_STATUS_BY_EVENT:
      return {
        ...state,
        client_email_event_status_error: null,
        client_email_event_status_loading: true,
      }

    case CHECK_CLIENT_EMAIL_STATUS_BY_EVENT_SUCCESS:
      return {
        ...state,
        client_email_event_status_error: null,
        client_email_event_status: action.payload,
        client_email_event_status_loading: false,
      }

    case CHECK_CLIENT_EMAIL_STATUS_BY_EVENT_ERROR:
      return {
        ...state,
        client_email_event_status_error: action.payload,
        client_email_event_status_loading: false,
      }

    case DELETE_CLIENT_EMAIL_STATUS_BY_EVENT:
      return {
        ...state,
        client_email_event_status_error: null,
        client_email_event_status_loading: true,
      }

    case DELETE_CLIENT_EMAIL_STATUS_BY_EVENT_SUCCESS:
      return {
        ...state,
        client_email_event_status_error: null,
        client_email_event_status: state.client_email_event_status.map(event => {
          if (event.email !== action.payload.email) {
            return event;
          }
          return {
            ...event,
            [action.payload.event.replace(/s$/, "")]: false
          }
        })
        ,
        client_email_event_status_loading: false,
      }

    case DELETE_CLIENT_EMAIL_STATUS_BY_EVENT_ERROR:
      return {
        ...state,
        client_email_event_status_error: action.payload,
        client_email_event_status_loading: false,
      }

    case RESET_CLIENT_EMAIL_TEMPLATE_BY_ID:
      return {
        ...state,
        client_email_template_logs_error: null,
        client_email_template_logs: null,
        client_email_template_logs_loading: false,
      }

    default:
      return state
  }
}

export default ClientEmailEvents
